import React from 'react';
import { oppMatrix } from './RiskOppMatrix';

const OppMatrixTable = () => {
  // Create a 2D array to hold the comments for the opportunity matrix
  const oppTable = Array(2).fill(null).map(() => Array(2).fill(''));

  // Populate the oppTable with values from the oppMatrix
  oppMatrix.forEach(item => {
    const { passionRange, profitRange, comment } = item;

    // Determine indices based on ranges
    const passionIndex = passionRange === "1-50" ? 0 : 1;
    const profitIndex = profitRange === "1-50" ? 0 : 1;

    oppTable[passionIndex][profitIndex] = comment;
  });

  return (
    <div className="p-4 text-sm bg-white text-blue-800">
      <div className="mb-8">
        <h3 className="text-xl font-bold mb-4 text-purple-600">Opportunity Matrix</h3>
        <div>
          <table className="w-full bg-white text-blue-800 border border-gray-300">
            <thead>
              <tr>
                <th className="px-2 py-1 border-b border-r text-white bg-blue-500 text-xs md:text-sm">Passion/Profit</th>
                <th className="px-2 py-1 border-b border-r text-white bg-blue-500 text-xs md:text-sm">1-50</th>
                <th className="px-2 py-1 border-b border-r text-white bg-blue-500 text-xs md:text-sm">51-100</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="px-2 py-1 border-b border-r text-blue-800 bg-gray-100 text-xs md:text-sm">51-100</td>
                <td className="px-2 py-1 border-b border-r text-blue-800 bg-gray-100 text-xs md:text-sm">
                  {oppTable[1][0]}
                </td>
                <td className="px-2 py-1 border-b border-r text-blue-800 bg-gray-100 text-xs md:text-sm">
                  {oppTable[1][1]}
                </td>
              </tr>
              <tr>
                <td className="px-2 py-1 border-b border-r text-blue-800 bg-gray-100 text-xs md:text-sm">1-50</td>
                <td className="px-2 py-1 border-b border-r text-blue-800 bg-gray-100 text-xs md:text-sm">
                  {oppTable[0][0]}
                </td>
                <td className="px-2 py-1 border-b border-r text-blue-800 bg-gray-100 text-xs md:text-sm">
                  {oppTable[0][1]}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default OppMatrixTable;
